/**
 * 首页翻译 - 中文
 * Homepage translations - Chinese
 */

export default {
  hero: {
    title: '智能基建·连接亚太',
    subtitle: 'Global Data 致力于通过领先的技术解决方案，赋能企业数字化转型，构建智能互联的未来',
    cta: '立即咨询',
    learnMore: '了解更多'
  },
  
  coreMetrics: {
    title: '核心数据看板',
    subtitle: '用数字说话，用实力证明',
    systemAvailability: '系统可用性',
    serviceRegions: '服务地区',
    clientsServed: '服务客户',
    certifications: '技术认证',
    highAvailability: '全年高可用保障',
    coveringAsiaPacific: '覆盖亚太主要市场',
    enterpriseClients: '累计服务企业客户',
    internationalCerts: '国际权威认证'
  },
  
  serviceRegions: {
    title: '服务覆盖地图',
    subtitle: '覆盖 11 个亚太服务地区，点击地图节点即可查看本地服务详情',
    viewAllRegions: '查看所有地区'
  },
  
  certifications: {
    title: '资质认证与合规能力',
    subtitle: '国际标准认证，多区域合规保障',
    viewAll: '查看所有认证',
    validUntil: '有效期至',
    issuedBy: '颁发机构',
    categories: {
      quality: '质量管理',
      security: '信息安全',
      telecom: '电信资质',
      technology: '技术合作伙伴',
      privacy: '隐私与合规'
    }
  },
  
  caseStudies: {
    title: '近期成功案例',
    subtitle: '真实案例，实力见证',
    filterByIndustry: '按行业筛选',
    allIndustries: '全部行业',
    finance: '金融',
    healthcare: '医疗',
    manufacturing: '制造',
    government: '政府',
    retail: '零售',
    professional: '专业服务',
    education: '教育',
    viewAllCases: '查看所有案例',
    viewDetail: '查看详情',
    outcome: '项目成果',
    industry: '行业',
    region: '地区',
    noResults: '当前暂无 {industry} 相关案例，请查看其他行业。',
    noCases: '暂无可展示案例。'
  },
  
  testimonials: {
    title: '客户评价',
    subtitle: '听听客户怎么说',
    rating: '评分'
  },
  
  regionalContact: {
    title: '联系我们',
    subtitle: '11 个服务地区，随时为您服务',
    office: '服务中心',
    phone: '联系电话',
    email: '邮箱地址',
    businessHours: '营业时间',
    viewContactPage: '查看完整联系信息'
  },
  
  cta: {
    title: '立即体验我们的产品',
    subtitle: 'Global Data 致力于为您提供最前沿的技术解决方案。我们的产品已经帮助数百家企业实现数字化转型，提升运营效率，驱动业务增长。',
    contact: '联系我们',
    trialNow: '立即试用'
  },
  
  news: {
    latest: '最新动态',
    industry: '行业洞察',
    company: '公司新闻',
    item1: {
      content: 'Global Data 与全球领先AI公司达成战略合作，共同探索AI新边界。',
      date: '2023年10月26日'
    },
    item2: {
      content: 'Global Data 发布2024年技术趋势报告，聚焦云计算与大数据。',
      date: '2023年10月20日'
    },
    item3: {
      content: 'Global Data 荣获"年度最佳科技创新企业"称号。',
      date: '2023年10月15日'
    }
  },
  
  insights: {
    title: '特色趋势与洞察',
    digitalTransformation: {
      title: '数字化转型：企业增长的新引擎',
      description: '深入探讨数字化转型如何重塑商业格局，以及Global Data如何助力企业实现高效转型。'
    },
    aiFuture: {
      title: 'AI与未来：智能时代的无限可能',
      description: '探索人工智能的最新进展及其在各行业的应用前景，Global Data的AI解决方案。'
    },
    bigData: {
      title: '大数据：洞察商业价值的源泉',
      description: '探索大数据如何赋能企业决策，以及Global Data如何提供全面的数据分析解决方案。'
    }
  },

  coreServices: {
    kicker: '企业服务',
    title: '核心服务',
    subtitle: '统一 SLA、跨区域协调与本地交付并重，为企业数字化全周期提供可靠基础设施与运维能力。',
    viewDetail: '查看详情',
    viewAllServices: '核心服务总览',
    items: [
      {
        sectionId: 'digital-workplace',
        eyebrow: '数字化工作场所',
        title: '桌面与终端体验',
        description: '统一终端、账号权限与协作工具支持，覆盖入离职、远程办公与资产全生命周期管理，提升员工生产力与办公体验。'
      },
      {
        sectionId: 'data-center-network',
        eyebrow: '网络与数据中心',
        title: '企业与门店网络',
        description: 'LAN/WAN/WiFi、交换机与防火墙部署维护，以及机房与数据中心运维，保障核心业务稳定与连续性。'
      },
      {
        sectionId: 'cloud-operations',
        eyebrow: '云计算与云运维',
        title: '云上架构与成本优化',
        description: '公有云/混合云部署与迁移、资源运维与安全监控，提升弹性扩展能力并优化云成本结构。'
      },
      {
        sectionId: 'retail-store-ops',
        eyebrow: '门店 IT 运维',
        title: '规模化门店交付',
        description: '面向多国多店的标准化运维、POS 与网络支持、新店开业与搬迁升级，降低营业中断风险。'
      }
    ]
  },

  productExtensions: {
    title: '数字化能力',
    subtitle: '在智能工单与 AI 分析平台之外，延伸提供 CRM 软件开发、MA 营销自动化、小程序、AI 知识库与办公智能体，推动运营向数据驱动演进。',
    viewAll: '查看产品能力',
    items: [
      {
        title: 'CRM软件开发',
        tagline: '会员体系与C端用户运营',
        description: '围绕品牌会员、用户标签、积分权益、互动触达与复购运营，构建面向 C 端用户管理的会员 CRM 平台。'
      },
      {
        title: 'MA营销自动化',
        tagline: '自动触达与转化增长',
        description: '连接官网、CRM、邮件与消息渠道，形成线索培育与营销旅程闭环。'
      },
      {
        title: '小程序',
        tagline: '轻量服务入口',
        description: '面向预约、报修、查询、会员服务等场景，提供小程序定制开发。'
      },
      {
        title: 'AI知识库',
        tagline: '知识沉淀与问答',
        description: '统一 FAQ、SOP、工单经验与产品资料，支持语义检索与权限管理。'
      },
      {
        title: '办公智能体',
        tagline: '办公流程自动化',
        description: '打通邮件、审批、会议纪要、任务流转与知识问答，提升内部协同效率。'
      }
    ]
  },
  
  mission: {
    title: '我们的使命',
    description: 'Global Data 致力于成为全球领先的科技服务提供商，通过持续创新和卓越服务，赋能客户实现业务增长和数字化转型，共同构建一个更智能、更互联的未来。我们坚信科技的力量，并以此为驱动，为社会创造价值。'
  },
  
  expertise: {
    title: '我们的专业领域',
    bigData: {
      title: '大数据与分析',
      description: '从数据采集到深度分析，帮助企业从海量数据中挖掘价值，驱动智能决策。'
    },
    ai: {
      title: '人工智能与机器学习',
      description: '开发和部署定制化AI解决方案，包括自然语言处理、计算机视觉和智能自动化。'
    },
    itConsulting: {
      title: 'IT咨询与管理',
      description: '提供战略性IT咨询、项目管理和IT运营优化，确保技术投资与业务目标一致。'
    }
  },
  
  services: {
    title: '我们的服务',
    ticketSystem: {
      title: '智能工单系统',
      subtitle: '高效管理您的服务请求与问题',
      description: '我们的智能工单系统旨在简化您的服务请求流程，从提交到解决，全程可视化。您可以实时追踪工单状态，了解处理进度，并与我们的技术团队无缝沟通。',
      features: {
        realTimeTracking: '实时状态追踪',
        multiChannel: '多渠道提交',
        smartAssignment: '智能分配',
        historyQuery: '历史记录查询'
      },
      progressTitle: '工单处理进度示例'
    },
    aiSolutions: {
      title: 'AI 赋能解决方案',
      subtitle: '利用人工智能驱动业务增长',
      description: '我们将最前沿的人工智能技术融入您的业务流程，提供定制化的AI解决方案，包括智能客服、数据预测、自动化决策等，助您提升效率，优化用户体验。',
      features: {
        chatbot: '智能客服机器人',
        biAnalytics: '商业智能分析',
        recommendation: '个性化推荐',
        security: '智能安全防护'
      },
      ctaButton: '了解AI解决方案'
    }
  }
}
